import InformationCard from './InformationCard.vue';

export { InformationCard };
export default InformationCard;
